import { DiffEditorModel } from 'ngx-monaco-editor-v2';

export function createDiffEditorModel(content: string, language = 'text'): DiffEditorModel {
  return {
    code: content,
    language: language
  };
}
